import { observer } from 'mobx-react-lite';
import Markdown, { Components } from 'react-markdown';
import remarkGfm from 'remark-gfm';
import remarkBreaks from 'remark-breaks';

import { twMerge } from 'tailwind-merge';
import { CommonLink } from '../CommonLink';

export const MarkdownViewer = observer(
    ({
        markdown = '',
        components = {},
        className,
    }: {
        markdown: string;
        /**
         * 컴포넌트 옵션
         * 예: 앵커 태그를 커스터마이징
         */
        components?: Components;
        className?: string;
    }) => {
        const content = markdown?.trim() || '';

        // prose 클래스에 대한 스타일은 tailwind.config.js 에서 설정함
        const defaultComponents: Components = {
            a: ({ href, children }) => <CommonLink to={href || ''}>{children}</CommonLink>,
            img: ({ src, alt }) => <img src={src} alt={alt} loading="lazy" className="w-full" />,
        };

        const mergedComponents = {
            ...defaultComponents,
            ...components,
        };

        return (
            <div className={twMerge('prose text-base-content max-w-none text-base', className)}>
                <Markdown
                    remarkPlugins={[
                        // github flavored markdown
                        remarkGfm,
                        // 줄바꿈 처리
                        remarkBreaks,
                    ]}
                    components={mergedComponents}
                >
                    {content}
                </Markdown>
            </div>
        );
    },
);
